import { Page } from "@towersystems/roam-common-native";
import React, { useCallback } from "react";
import { SelectMfaMethodFieldset } from "../../components/SetupNative2faForm/components";
import { useFocusEffect } from "@react-navigation/native";
import { useFormContext } from "react-hook-form";
import { SetupNative2faFormValues } from "../../components/SetupNative2faForm/types";
import { useTranslation } from "../../../../utilities/i18n";

export const Native2faMethodSelectScreen = ({ navigation }: any) => {
  const { t } = useTranslation("settings");
  const { getValues, reset } = useFormContext<SetupNative2faFormValues>();

  // undo any form state from future steps if we come back to this screen
  // it also resets the isSubmitSuccessful flag on the form ready
  // for a new submission
  useFocusEffect(
    useCallback(() => {
      const values = getValues();
      reset({
        ui: {
          ...values.ui,
          codeSent: false,
        },
        data: {
          ...values.data,
          password: undefined,
          code: undefined,
          identifier: undefined,
        },
      });
    }, [reset])
  );

  return (
    <Page
      title={t("title.native_2fa_method_select")}
      secondaryTitle={t("title.native_2fa_method_select_secondary")}
    >
      <SelectMfaMethodFieldset
        onComplete={() => navigation.navigate("Native2faEnterIdentifierScreen")}
      />
    </Page>
  );
};
